import { DownloadSimple, ArrowsOut, BookOpen } from "@phosphor-icons/react";
import { IMG } from "@/lib/products";
import { useLang } from "@/lib/i18n";
import { PageHero } from "@/components/PageBits";
import { Reveal } from "@/components/Reveal";
import { CATALOGUE_PDF } from "@/lib/site";

export default function Catalogue() {
  const { t } = useLang();

  const openFullScreen = () => {
    const iframe = document.getElementById("catalogue-viewer");
    if (!iframe) return;
    if (iframe.requestFullscreen) iframe.requestFullscreen();
    else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
    else window.open(CATALOGUE_PDF, "_blank", "noopener,noreferrer");
  };

  return (
    <div data-testid="catalogue-page">
      <PageHero
        eyebrow={t("catalogue.eyebrow")}
        title={t("catalogue.title")}
        subtitle={t("catalogue.subtitle")}
        image={IMG.factory}
      />

      <section className="container-x py-16 md:py-24">
        <Reveal>
          <div className="mb-8 flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
            <div className="max-w-2xl">
              <p className="overline mb-3">{t("catalogue.eyebrow")}</p>
              <h2 className="font-heading text-3xl font-extrabold tracking-tight text-forest md:text-4xl">
                {t("catalogue.heading")}
              </h2>
              <p className="mt-4 text-ink/70">{t("catalogue.description")}</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href={CATALOGUE_PDF}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold"
                data-testid="catalogue-download-btn"
              >
                <DownloadSimple size={20} weight="bold" />
                {t("catalogue.downloadBtn")}
              </a>
              <button
                onClick={openFullScreen}
                className="btn-outline-forest"
                data-testid="catalogue-fullscreen-btn"
              >
                <ArrowsOut size={18} weight="bold" />
                {t("catalogue.fullScreen")}
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            className="overflow-hidden rounded-3xl border border-hairline bg-white shadow-sm"
            data-testid="catalogue-viewer-wrap"
          >
            <iframe
              id="catalogue-viewer"
              title="RK Jain Product Catalogue"
              src={`${CATALOGUE_PDF}#view=FitH&toolbar=1&navpanes=1`}
              className="h-[70vh] min-h-[520px] w-full md:h-[85vh]"
              allow="fullscreen"
              data-testid="catalogue-iframe"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-6 flex items-center gap-3 rounded-2xl border border-hairline bg-champagne p-5 text-sm text-ink/70">
            <BookOpen size={22} weight="fill" className="shrink-0 text-gold" />
            <p>{t("catalogue.mobileNote")}</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
